import React from 'react';

import { useSelector } from 'react-redux';

import useElementBottomPosition, { SNACKBAR_POSITION } from 'hooks/useElementBottomPosition';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { isDefined } from 'utils/ramda';

import DetailsChronologicalMode from './DetailsChronologicalMode';
import { magicImportModalManager } from './DetailsChronologicalMode/MagicImportModals/MagicImportStatusModal/modalManager';
import DetailsOriginalMode from './DetailsOriginalMode';
import { EDetailsMode } from './types';

function Details() {
  useElementBottomPosition(SNACKBAR_POSITION);
  const itinerary = useSelector(itinerariesItemDataSelector);

  React.useEffect(() => {
    if (isDefined(itinerary?.magicImport)) {
      const { status, id, result } = itinerary.magicImport;

      if (status === 'processing' || status === 'pending') {
        magicImportModalManager.showProcessingModal();
      } else if (status === 'completed' && isDefined(result)) {
        magicImportModalManager.showCompletedModal(id);
      }
    }
  }, [itinerary?.magicImport]);

  if (itinerary.detailsMode !== EDetailsMode.Chronological) {
    return <DetailsOriginalMode />;
  }

  return <DetailsChronologicalMode />;
}

export default Details;
